<template>
    <div class="chat-view-container">
        <div class="chat-top-bar d-flex align-items-center flex-shrink-0 p-3 link-body-emphasis text-decoration-none">
            <div class="align-items-center" id="chat-top">
                <i class="fas fa-arrow-right chat-back-icon"></i>
                <div class="logo-container">
                    <img class="rounded-circle border profile-img" width="50" :src="chat.logo" alt="">
                    <span class="mb-1 company-name">{{ chat.name }}</span>
                </div>
            </div>
            <i v-if="chat && chat.id" @click="toggleSearch" class="fas fa-search search-icon-top"></i>
        </div>
        <div class="chat-section flex-grow-1 overflow-auto" @scroll="handleScroll">
            <!-- نمایش پیام‌های خوانده‌شده -->
            <div v-for="message in readMessages" :key="message.id">
                <ChatBubble :message="message" />
            </div>

            <!-- نمایش بخش پیام‌های جدید در صورت وجود پیام‌های خوانده‌نشده -->
            <div v-if="unreadMessages.length > 0" id="new-message-row" class="new-message-container">
                <div class="new-message-row">
                    <span class="new-message-title">پیام‌های جدید</span>
                    <i class="fas fa-angle-double-down"></i>
                </div>
            </div>

            <!-- نمایش پیام‌های خوانده‌نشده -->
            <div v-for="message in unreadMessages" :key="message.id">
                <ChatBubble :message="message" />
            </div>

            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12">
                        <div v-if="showSearchBar" class="search-container">
                            <input type="text" class="form-control chat-search-input" placeholder="جستجو">
                            <i class="fas fa-search search-icon"></i>
                        </div>
                    </div>
                </div>
            </div>
            <button 
                v-if="!isAtBottom" 
                class="btn btn-primary float-btn" 
                @click="scrollToBottom">
                <i class="fas fa-arrow-down"></i>
            </button>
        </div>
    </div>
</template>

<script>
import ChatBubble from '@/components/ChatBubble.vue';
import axios from 'axios';
import { nextTick } from 'vue';

export default {
    name: 'ChatView',
    props: {
        chat: Object,
        messages: Array
    },
    data() {
        return {
            showSearchBar: false,
            isAtBottom: true,
            scroll: true
        };
    },
    computed: {
        // پیام‌های خوانده‌شده
        readMessages() {
            return this.messages
                .filter(message => message.is_read && message.from === this.chat.id);
        },
        // پیام‌های خوانده‌نشده
        unreadMessages() {
            return this.messages
                .filter(message => !message.is_read && message.from === this.chat.id);
        }
    },
    mounted() {
        // this.scrollToLastReadMessage();
    },
    updated() {
        if (!this.isAtBottom && this.scroll === true) {
            this.scrollToLastReadMessage();
            nextTick(() => {
                this.scroll = false
            })
        }
    },
    watch: {
        showSearchBar() {
            if (this.showSearchBar) {
                nextTick(() => {
                    this.scrollToBottom();
                })
            }
        }
    },
    methods: {
        scrollToLastReadMessage() {
            this.$nextTick(() => {
                if (this.readMessages.length > 0) {
                    const lastReadMessageId = this.readMessages[this.readMessages.length - 1].id;
                    const lastReadMessageElement = this.$el.querySelector(`#${CSS.escape(lastReadMessageId)}`);
                    if (lastReadMessageElement) {
                        lastReadMessageElement.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                }
            });
            nextTick(() => {
                this.updateMessagesReadStatus()
            });
        },
        scrollToBottom() {
            this.$nextTick(() => {
                const chatSection = this.$el.querySelector('.chat-section');
                if (chatSection) {
                    chatSection.scrollTop = chatSection.scrollHeight;
                }
            });
        },
        handleScroll() {
            const chatSection = this.$el.querySelector('.chat-section');
            if (chatSection) {
                const isBottom = chatSection.scrollHeight - chatSection.scrollTop <= chatSection.clientHeight + 10;
                this.isAtBottom = isBottom;
            }
        },
        toggleSearch() {
            this.showSearchBar = !this.showSearchBar;
            if (this.showSearchBar) {
                nextTick(() => {
                    //focus on search input
                    const searchInput = document.querySelector('.chat-search-input');
                    searchInput.focus();
                    this.scrollToBottom();
                })
            }
        },
        async updateMessagesReadStatus() {
            nextTick(() => {
                try{
                    this.unreadMessages.forEach(message => {
                        axios.patch(`https://api.noticapp.ir/v1/messages/${message.id}`, {
                            is_read: true,
                        }, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('token')}`
                            }
                        })
                    });
                } catch (error) {
                    console.log(`Error marking message ${error.message.id} as read: `, error);
                }
            });
        },
    },
    components: {
        ChatBubble,
    },
};
</script>

<style scoped>

.chat-view-container {
    background-color: #5a6165;
    background-image:  linear-gradient(135deg, #4c575d 25%, transparent 25%), linear-gradient(225deg, #4c575d 25%, transparent 25%), linear-gradient(45deg, #4c575d 25%, transparent 25%), linear-gradient(315deg, #4c575d 25%, #5a6165 25%);
    background-position:  40px 0, 40px 0, 0 0, 0 0;
    background-size: 80px 80px;
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.chat-top-bar {
    cursor: pointer;
    background-color: #25292E;
    color: white;
    z-index: 10;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

#chat-top {
    display: none;
}

.profile-img {
    /* margin: auto 0 auto 15px; */
    border: none !important;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #1B1E23;
    width: 45px;
    height: 45px;
    object-fit: cover;
    margin-left: 15px;
}

.company-name {
    font-size: 25px;
    font-weight: normal;
    color: #fff;
}

.search-icon-top {
    display: block;
    font-size: 30px;
    margin: 0 10px;
    color: white;
    cursor: pointer;
}

.chat-section {
    height: calc(100vh - 60px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px;
    scroll-behavior: smooth;
    transition: all 0.1s; 
    align-content: end;
}

.chat-section::-webkit-scrollbar {
    width: 5px;
}

.chat-section::-webkit-scrollbar-track {
    background-color: transparent;
    transition: background-color 0.5s;
}

.chat-section::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
    transition: background-color 0.5s;
}

.chat-section:hover::-webkit-scrollbar-thumb {
    background-color: #028D92;
}
.chat-section:hover::-webkit-scrollbar-track {
    background-color: #1B1E23;
}

.new-message-container {
    height: 50px;
}

.new-message-row {
    display: flex;
    /* justify-content: space-evenly; */
    justify-content: center;
    background-color: #25292E;
    align-items: center;
    color: #fff;
    border-radius: 15px;
    padding: 5px;
}

.new-message-title {
    margin-left: 10px;
}

.search-container {
    position: relative;
}

.chat-search-input {
    border-radius: 15px;
    padding: 10px 20px;
    padding-right: 40px;
    border: none;
    color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #1B1E23;
}

.search-input:focus {
    outline: none;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    background-color: #1B1E23;
    color: #fff;
}

.search-input::placeholder {
    color: #888;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    color: #888;
}

.chat-back-icon {
    display: none;
}

@media (width < 760px) {
    .chat-back-icon {
        display: block;
        font-size: 30px;
        color: white;
        cursor: pointer;
        margin-left: 10px;
        align-content: center;
        justify-content: center;
        align-items: center;
    }
}

</style>